module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/51.635c4455.png";